import 'bootstrap/dist/css/bootstrap.min.css';
import './styles.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import ChatApp from './ChatApp';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <ChatApp />
  </React.StrictMode>
);
